import type React from 'react';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Modal } from 'components';
import { URLS } from '../../../utils/urls';
import { navigate } from '../../../utils/navigate';
import { selectContentId, selectContentType, selectIsDocumentLocked, setIsLocked } from '../grid/reduxStore/documentSettingsSlice';
import { useAppDispatch, useAppSelector } from '../grid/reduxStore/Store';
import { contentQueries } from 'services/content/contentQueries';

const DocumentLockedModal: React.FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();
  const contentId = useAppSelector(selectContentId);
  const contentType = useAppSelector(selectContentType);
  const { data } = useQuery(contentQueries.contentMetadataById(contentType, contentId));

  useEffect(() => {
    if (data?.isLocked !== undefined) {
      dispatch(setIsLocked(data.isLocked));
    }
  }, [data?.isLocked, dispatch]);

  const isLocked = useAppSelector(selectIsDocumentLocked);

  const handlePreviewRedirect = () => navigate(URLS.previewByContentId(contentId));

  const handleDocumentsRedirect = () => {
    navigate(URLS.documents);
  };

  if (!isLocked) return null;

  return (
    <Modal
      isVisible
      handleOk={handlePreviewRedirect}
      handleCancel={handleDocumentsRedirect}
      affirmText={t('document.locked.go_to_preview')}
      cancelText={t('document.locked.go_to_pipeline')}
      title={t('document.locked.title')}
      closable={false}
      maskClosable={false}
      escClosable={false}
    >
      <p>{t('document.locked.message')}</p>
    </Modal>
  );
};

export default DocumentLockedModal;
